// ══════════════════════════════════════════════════════════════
// COMPASS – Process Risk Results Codes
// ══════════════════════════════════════════════════════════════

/** Risk results set by hand refused because the process is REJECTED (US-010; COMPLETED no longer, US-002): its status changed under
 *  the open page. */
export const RISK_RESULTS_LOCKED = 'error.kyc.risk-matrix.results-locked';

/** A reassessment date set by hand before the assessment: the results form shows it at the date, not as a toast
 *  (US-011). */
export const RISK_RESULTS_DATE_BEFORE_ASSESSMENT = 'error.kyc.risk-matrix.reassessment-date-before-assessment';
